import React, { useState } from "react";
import { Helmet } from "react-helmet";
import ActivePage from "../../../partials/active-page";
import { appName } from "../../../app.json";
import { useQuery, useMutation } from "@apollo/react-hooks";
import auth from "../../../providers/Auth.Provider";
import NewStaffType from "./NewStaffType";
import EditStaffType from "./EditStaffType";
import StaffTypeList from "./StaffTypeList";
import {
	GET_STAFF_TYPE,
	NEW_STAFF_TYPE,
	UPDATE_STAFF_TYPE
} from "../../../queries/staffType.query";
import LoadingSpinner from "../../../partials/loading";
import AlertMessage from "../../../partials/alertMessage";

const StaffType = ({ match }) => {
	const [newType, setNewType] = useState(false);
	const [staffType, setStaffType] = useState(null);
	const [message, setMessage] = useState(null);

	const title = "Staff Type";
	const pages = [
		{
			title,
			path: match.path
		}
	];

	//Get authenticated user's authentication info
	const {
		GetToken,
		GetAuthenticatedStaff,
		IsAuthenticationError,
		LogOut
	} = auth.authProvider;
	const { site } = GetToken() && GetAuthenticatedStaff();

	// Fetch list of Staff type
	const { loading, error, data } = useQuery(GET_STAFF_TYPE, {
		variables: { siteId: site && site.id }
	});

	//New Staff type
	const [
		createStaffType,
		{ loading: cLoading, error: cError, data: cData }
	] = useMutation(NEW_STAFF_TYPE, {
		// Update cache
		update(caches, { data: { CreateStaffType } }) {
			const { GetAllStaffType } = caches.readQuery({
				query: GET_STAFF_TYPE,
				variables: { siteId: site && site.id }
			});
			GetAllStaffType.docs.unshift(CreateStaffType.doc);
			caches.writeQuery({
				data: { GetAllStaffType },
				query: GET_STAFF_TYPE,
				variables: { siteId: site && site.id }
			});
		}
	});

	// Update Staff type
	const [
		UpdateStaffType,
		{ loading: uLoading, error: uError, data: uData }
	] = useMutation(UPDATE_STAFF_TYPE);

	if (error && IsAuthenticationError(error.message)) LogOut();

	return (
		<>
			<Helmet>
				<title>
					{title} | {appName}
				</title>
			</Helmet>
			<ActivePage pages={pages} title={title} />

			<div className="row justify-content-center">
				{/* New Staff type container */}
				{newType && (
					<div className="col-md-10 fade-in">
						<div className="card">
							<div className="card-head">
								<header>New Staff Type</header>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={cLoading} />
								<AlertMessage
									message={cError && cError.message}
									failed={true}
								/>
								<AlertMessage
									message={
										cData && cData.CreateStaffType.message
									}
								/>

								<NewStaffType
									onSubmit={name => {
										createStaffType({
											variables: {
												name,
												site: site && site.id
											}
										});
									}}
									onCancel={() => {
										setNewType(!newType);
									}}
								/>
							</div>
						</div>
					</div>
				)}

				{/* Edit Staff type container */}
				{staffType && (
					<div className="col-md-10 fade-in">
						<div className="card">
							<div className="card-head">
								<header>
									<span className="text-muted">Edit</span>{" "}
									{staffType.name}
								</header>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={uLoading} />
								<AlertMessage
									message={uError && uError.message}
									failed={true}
								/>
								<AlertMessage message={message} />
								<EditStaffType
									currentValue={staffType && staffType.name}
									onSubmit={async name => {
										await UpdateStaffType({
											variables: {
												id: staffType.id,
												name
											}
										});
										setMessage(
											uData.UpdateStaffType.message
										);
										setTimeout(() => {
											setStaffType(null);
											setMessage(null);
										}, 2000);
									}}
									onCancel={() => {
										setStaffType(null);
										setMessage(null);
									}}
								/>
							</div>
						</div>
					</div>
				)}

				{/* List of Staff types container */}
				<div className="col-md-10">
					<div className="card">
						<div className="card-head">
							<header>Staff Type List</header>
							<div className="tools">
								<button
									onClick={() => {
										setNewType(!newType);
										document.body.scrollTop = 0;
										document.documentElement.scrollTop = 0;
									}}
									className="mdl-button mdl-js-button mdl-button--icon btn-circle btn-success"
									data-upgraded=",MaterialButton"
								>
									<i className="material-icons">add</i>
								</button>
							</div>
						</div>
						<div className="card-body">
							<LoadingSpinner loading={loading} />
							<AlertMessage
								message={error && error.message}
								failed={true}
							/>
							{!loading && (
								<StaffTypeList
									items={data && data.GetAllStaffType.docs}
									onEdit={item => setStaffType(item)}
								/>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default StaffType;
